import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  fullContainer: {
    backgroundColor: '$colorBgPrimaryLight',
  },
  outerContainer: {
    width: '100%',
    backgroundColor: '$colorBgBase',
  },
  containerStyle: {
    maxWidth: 960,
  },
  summary: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    paddingTop: '$space2',
  },
  summaryColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '$colorTextMedium',
    flex: 1,
  },
  horizontalDivider: {
    borderLeftWidth: '$borderWidth1',
    borderLeftStyle: '$borderStyle',
    borderLeftColor: '$colorBgPrimaryMediumLight',
  },
  summaryDetailContainer: {
    backgroundColor: '$colorBgPrimaryLight',
    maxWidth: 960,
  },
  summaryDetail: {
    display: 'flex',
    flexDirection: 'column',
  },
  referredRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '$space4',
  },
});
